import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function createGroup(body) {
  try{
    let userResponsible = body.userResponsible.map((responsible)=>responsible.value)
    let userParticipant = body.userParticipant.map((participant)=>participant.value)
    const newBody = {
      ...body, userResponsible,userParticipant
    }
    const data = await axios.post(`${REACT_APP_API}/groups/`,newBody) 
    return data?.data
  }catch(error){
      throw new Error(error)
  }
}